module.exports = __webpack_public_path__ + "b56b6123726af40425788f04029da3d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/school/Classroom1.jpg
// module id = 3575
// module chunks = 0